/* eslint-disable import/first */
import React, { useState } from 'react';
import Hreflang from '../../components/Hreflang';
import { Grid, Container } from '@material-ui/core';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;

const { selectDesktop } = Slices.appSlice;
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { FormattedMessage, useIntl } from 'react-intl';
import SeoTitle from '../../components/SeoTitle';
import css from './index.module.scss';

import { FiPlus } from '@react-icons/all-files/fi/FiPlus';
import { FiMinus } from '@react-icons/all-files/fi/FiMinus';

import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  makeStyles,
} from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: 'white',
    padding: '2rem',
    margin: 0,
    [theme.breakpoints.down('xs')]: {
      backgroundColor: '#f7fafe',
    },
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#f7fafe',
    },
  },
  card: {
    boxShadow: '0px 4px 2px 0px #DBE5F2 !important',
    maxWidth: '100%',
    margin: '0 auto',
    marginBottom: '2rem',
    borderRadius: '1rem',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  expandIcon: {
    fontSize: '3rem',
    fontWeight: 'bold',
  },
}));

function PrivacyPolicy() {
  const isDesktop = useSelector(selectDesktop);
  const intl = useIntl();
  const classes = useStyles();
  const [expanded, setExpanded] = useState(0);

  const obj = [
    {
      header: <FormattedMessage id="privacy_li1" />,
      desc: intl.formatMessage({ id: 'privacy_detail1' }),
    },
    {
      header: <FormattedMessage id="privacy_li2" />,
      desc: intl.formatMessage({ id: 'privacy_detail2' }),
    },
    {
      header: <FormattedMessage id="privacy_li3" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail3.1' }),
        intl.formatMessage({ id: 'privacy_detail3.2' }),
        intl.formatMessage({ id: 'privacy_detail3.3' }),
        intl.formatMessage({ id: 'privacy_detail3.4' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li4" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail4' }),
        intl.formatMessage({ id: 'privacy_detail4.1' }),
        intl.formatMessage({ id: 'privacy_detail4.2' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li5" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail5' }),
        intl.formatMessage({ id: 'privacy_detail5.1' }),
        intl.formatMessage({ id: 'privacy_detail5.2' }),
        intl.formatMessage({ id: 'privacy_detail5.3' }),
        intl.formatMessage({ id: 'privacy_detail5.4' }),
        intl.formatMessage({ id: 'privacy_detail5.5' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li6" />,
      desc: intl.formatMessage({ id: 'privacy_detail6' }),
    },
    {
      header: <FormattedMessage id="privacy_li7" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail7' }),
        intl.formatMessage({ id: 'privacy_detail7.1' }),
        intl.formatMessage({ id: 'privacy_detail7.2' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li8" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail8' }),
        intl.formatMessage({ id: 'privacy_detail8.1' }),
        intl.formatMessage({ id: 'privacy_detail8.2' }),
        intl.formatMessage({ id: 'privacy_detail8.3' }),
        intl.formatMessage({ id: 'privacy_detail8.4' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li9" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail9' }),
        intl.formatMessage({ id: 'privacy_detail9.1' }),
      ],
    },
    {
      header: <FormattedMessage id="privacy_li10" />,
      desc: intl.formatMessage({ id: 'privacy_detail10' }),
    },
    {
      header: <FormattedMessage id="privacy_li11" />,
      desc: intl.formatMessage({ id: 'privacy_detail11' }),
    },
    {
      header: <FormattedMessage id="privacy_li12" />,
      desc: intl.formatMessage({ id: 'privacy_detail12' }),
    },
    {
      header: <FormattedMessage id="privacy_li13" />,
      desc: [
        intl.formatMessage({ id: 'privacy_detail13' }),
        intl.formatMessage({ id: 'privacy_detail13.1' }),
        intl.formatMessage({ id: 'privacy_detail13.2' }),
        intl.formatMessage({ id: 'privacy_detail13.3' }),
        intl.formatMessage({ id: 'privacy_detail13.4' }),
        intl.formatMessage({ id: 'privacy_detail13.5' }),
        intl.formatMessage({ id: 'privacy_detail13.6' }),
      ],
    },
  ];

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid className={css.root}>
      <SeoTitle id="privacy" />
      <Hreflang page="privacy" />
      <Header
        title={<FormattedMessage id="navigation_privacyPolicy" defaultMessage="Privacy Policy" />}
        actionButtons={[<LanguageButton />]}
      />
      <div className={css.wrapper}>
        {isDesktop && (
          <div className={css.pageHeading}>
            <FormattedMessage id="navigation_privacyPolicy" defaultMessage="Privacy Policy" />
          </div>
        )}
        <Container className={classNames(classes.container, css.wrapper)}>
          {obj.map(({ header, desc }, index) => {
            return (
              <Accordion
                key={index}
                className={classes.card}
                expanded={expanded === index}
                onChange={handleAccordionChange(index)}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === index ? (
                      <FiMinus className={classes.expandIcon} />
                    ) : (
                      <FiPlus className={classes.expandIcon} />
                    )
                  }
                  aria-controls={`panel${index}-content`}
                  id={`panel${index}-header`}
                >
                  <Typography
                    className={classNames(
                      css.headingStyle,
                      { [css.inactive]: expanded !== index },
                      { [css.active]: expanded === index }
                    )}
                  >
                    {header}
                  </Typography>
                </AccordionSummary>
                <hr className={css.hrLine} />
                <AccordionDetails>
                  <Typography className={css.descp}>
                    {Array.isArray(desc) ? (
                      desc.map((description, descIndex) => {
                        return (
                          <React.Fragment key={descIndex}>
                            {description.startsWith('•') ? (
                              <div className={css.tabSpace}>
                                {Array(3).fill(' ').join('')}
                                {description}
                                <br />
                              </div>
                            ) : (
                              description
                            )}
                            <div className={css.paraStyle} />
                          </React.Fragment>
                        );
                      })
                    ) : header.props.id === 'privacy_li6' ? (
                      <div className={css.tableRow} dangerouslySetInnerHTML={{ __html: desc }} />
                    ) : (
                      desc
                    )}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </Container>
      </div>
    </Grid>
  );
}

export default PrivacyPolicy;
